import { render, staticRenderFns } from "./CompanyCalculationForm.vue?vue&type=template&id=31a8ccfd&scoped=true&"
import script from "./CompanyCalculationForm.vue?vue&type=script&lang=js&"
export * from "./CompanyCalculationForm.vue?vue&type=script&lang=js&"
import style0 from "./CompanyCalculationForm.vue?vue&type=style&index=0&id=31a8ccfd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a8ccfd",
  null
  
)

export default component.exports